// @ts-nocheck

class GalleryDragScroll {
  constructor() {
    this.dragThreshold = 6;
    this.sliderEl = null;
    this.hasDragged = false;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.snapTimeout = null;

    this.setupEvents();
  }

  setupEvents() {
    document.addEventListener('pointerdown', (e) => this.onPointerDown(e));
    document.addEventListener('pointermove', (e) => this.onPointerMove(e));
    document.addEventListener('pointerup', () => this.onPointerUp());
    document.addEventListener('click', (e) => this.onClick(e), true);
    document.addEventListener('dragstart', (e) => this.onDragStart(e));
  }

  onPointerDown(e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    const sliderEl = e.target.closest('media-gallery .product__media-list');
    if (!sliderEl || sliderEl.scrollWidth <= sliderEl.clientWidth) return;
    this.sliderEl = sliderEl;
    this.hasDragged = false;
    this.startX = e.clientX;
    this.startScrollLeft = sliderEl.scrollLeft;
    clearTimeout(this.snapTimeout);
  }

  onPointerMove(e) {
    if (!this.sliderEl) return;
    const deltaX = e.clientX - this.startX;
    if (!this.hasDragged && Math.abs(deltaX) < this.dragThreshold) return;
    if (!this.hasDragged) {
      this.hasDragged = true;
      this.sliderEl.style.scrollSnapType = 'none';
      this.sliderEl.classList.add('is-dragging');
    }
    this.sliderEl.scrollLeft = this.startScrollLeft - deltaX;
  }

  onPointerUp() {
    if (!this.sliderEl) return;
    const sliderEl = this.sliderEl;
    this.sliderEl = null;
    if (!this.hasDragged) return;
    sliderEl.classList.remove('is-dragging');
    this.settleToNearestSlide(sliderEl);
    setTimeout(() => {
      this.hasDragged = false;
    }, 0);
  }

  onClick(e) {
    if (!this.hasDragged) return;
    e.preventDefault();
    e.stopPropagation();
    this.hasDragged = false;
  }

  onDragStart(e) {
    if (this.sliderEl) e.preventDefault();
  }

  settleToNearestSlide(sliderEl) {
    const slides = sliderEl.querySelectorAll('.product__media-item:not(.hidden)');
    if (!slides.length) return;
    let nearestLeft = 0;
    let nearestDistance = Infinity;
    slides.forEach((slide) => {
      const distance = Math.abs(slide.offsetLeft - sliderEl.scrollLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestLeft = slide.offsetLeft;
      }
    });
    sliderEl.scrollTo({ left: nearestLeft, behavior: 'smooth' });
    this.snapTimeout = setTimeout(() => {
      sliderEl.style.scrollSnapType = '';
    }, 600);
  }
}

new GalleryDragScroll();
